export default {"src":"/_next/static/image/public/images/profile.5bab8b1e859017643b1df32c93c9c6dd.svg","height":20,"width":20};